import { render, staticRenderFns } from "./datatable-column.vue?vue&type=template&id=4c003a8c&"
import script from "./datatable-column.vue?vue&type=script&lang=js&"
export * from "./datatable-column.vue?vue&type=script&lang=js&"
import style0 from "./datatable-column.vue?vue&type=style&index=0&id=4c003a8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports